import authInterceptor from "../AuthInterceptor";

export const UpdateRankAPI = {
    dragandupdateRank: (bodyData) =>
        authInterceptor.post(`ranking-api/update-rank/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response)
}